<template>
  <div class="premium-box">
    <h3 class="color-dark">Premium</h3>
    <div class="box">
      <el-form
        ref="premiumForm"
        :model="formData"
        :disabled="disabled"
        :rules="rules">
        <div class="table">
          <template v-if="list.length>0">
            <div
              v-for="(item,index) in list"
              :key="'premium'+index"
              class="style-1 premium-table"
            >
              <div class="premium-item__title">
                <div class="flex-sb-center">
                  <span > {{ item.title }}</span>
                  <span>{{item.min_tip}}</span>
                </div>
              </div>
              <div
                v-for="(contents,contentIndex) in item.items"
                :key="'contents'+contentIndex"
                class="tr">
                <span> {{ contents.item }}</span>
                <div class="flex flex-algin right">
                  <span
                    class="">
                    <el-form-item
                      :ref="`premium.${index}.items.${contentIndex}.val`"
                      :prop="`premium.${index}.items.${contentIndex}.val`"
                      :rules="rules.premium_input">
                      <v-input
                        v-model="contents.val"
                        prepend="$"
                        :keyFloatNumber="true"
                        maxlength="8"
                        :disabled="contents.is_enable==0||disabled"
                        @blur="handlerComputed"
                      />
                    </el-form-item>
                  </span>
                </div>
              </div>

            </div>
          </template>

          <div class="tr mg-t-8 top-border">
            <span>Additional Premium</span>
            <div class="flex flex-algin right">
              <span
                class="">
                <el-form-item  :rules="rules.input">
                  <v-input
                    v-model="formData.premium_other.additional_charge"
                    prepend="$"
                    :keyFloatNumber="true"
                    maxlength="8"
                    :disabled="disabled"
                    @blur="handlerComputed"
                  />
                </el-form-item>
              </span>
            </div>
          </div>

          <div class="tr mg-t-8 top-border">
            <span>ECI Levy ({{formData.premium_other.ec_levy_pct||0}}%)</span>
            <div class="flex flex-algin right">
              <span  class="right">
                {{formData.premium_other.ec_levy_vl| formatMoney(2, true)}}
              </span>
            </div>
          </div>
          <div class="tr mg-t-8 top-border">
            <span>IA Levy ({{formData.premium_other.ia_levy_pct||0}}%)</span>
            <div class="flex flex-algin right">
              <span  class="right">
                {{formData.premium_other.ia_levy_vl| formatMoney(2, true)}}
              </span>
            </div>
          </div>
          <div class="tr style-4 blue_tr mg-t-8">
            <span>Gross Premium</span>
            <span class="total">{{formData.premium_other.gross | formatMoney(2, true)}}</span>
          </div>


          <!-- discount -->
          <div
            class="tr mg-t-8 top-border">
            <span>Referral Discount</span>
            <span  class="right">
              {{formData.premium_other.code_disc_prm| formatMoney(2, true)}}
            </span>
          </div>
          <div
            class="tr">
            <span>Coupon Discount</span>
            <span class="right">
              {{formData.premium_other.coupon_vl| formatMoney(2, true)}}
            </span>
          </div>
          <div
            class="tr">
            <span>Promo Discount</span>
            <el-form-item>
              <span>
                <v-input
                  v-model.number="formData.premium_other.promo_disc_prm"
                  prepend="-$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  :disabled="disabled"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div class="tr">
            <span>Manual Discount </span>
            <el-form-item >
              <span>
                <v-input
                  v-model.number="formData.premium_other.spec_disc_prm"
                  prepend="-$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  :disabled="disabled"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div  class="tr">
            <span>Insurer Admin Charge  </span>
            <el-form-item
              ref="insurer_handling_fee"
              prop="insurer_handling_fee">
              <span>
                <v-input
                  v-model.number="formData.premium_other.insurer_handling_fee"
                  prepend="+$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  :disabled="disabled"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div  class="tr">
            <span>Agency Admin Charge</span>
            <el-form-item
              ref="agency_handling_fee"
              prop="agency_handling_fee">
              <span>
                <v-input
                  v-model.number="formData.premium_other.agency_handling_fee"
                  prepend="+$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  :disabled="disabled"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div class="tr">
            <span>Admin Charge </span>
            <el-form-item>
              <span>
                <v-input
                  v-model.number="formData.premium_other.handling_fee"
                  prepend="+$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  disabled
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div class="tr purple_tr">
            <div class="  mg-t-8">
              <div class="flex-sb-center ">
                <span>Premium Payable</span>
                <span
                  class="text-right">{{ formData.premium_other.total_prm | formatMoney(2, true) }}</span>
              </div>
              <span
                v-if="isOutCoupon&&formData.is_match==0"
                class="error-tip">{{formData.is_match_tip}}</span>

            </div>
          </div>
        </div>
      </el-form>
    </div>
    <premium-select-code
      ref="select-code"
      :orderId="orderId"
      :notApply="true"
      :isQuote="false"
      :customerId="customerId"
      :classId="classId"
      :customer="customer"
      :form="coupon_form"
      :isOutCoupon="isOutCoupon"
      :is-sme="true"
      :disabled="disabled"
      @open="handleOpenCoupon"
      @check-code="applyCode"
    ></premium-select-code>
  </div>
</template>

<script>
import premiumSelectCode from '@/views/components/premium-select-code'
import {getSMEReferMain} from '@api/sme'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFormat from '@/mixins/format'

export default {
  name: 'SMEPremiumForm',
  components: {
    premiumSelectCode,
  },
  mixins: [MixinOptions, MixinRules, MixinFormat],
  props:{
    form: {
      type: Object,
      default: () => ({})
    },
    classId:{
      type: [String,Number],
      default: ''
    },
    referId:{
      type: [String,Number],
      default: ''
    },
    orderId:{
      type: [String,Number],
      default: ''
    },
    customerId:{
      type: [String,Number],
      default: ''
    },
    disabled:{
      type:Boolean,
      default: false
    },
    isOutCoupon:{
      type:Boolean,
      default: false
    },
    customer:{
      type: Object,
      default: () => ({})
    },
  },
  data(){
    const checkInput = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = Number(field_arr[1])
      const items_index = Number(field_arr[3])
      const data = this.formData.premium[index]||{}
      let {items} = data||{}
      const val = items[items_index].val
      const valueResult = val !== null && val !== ''
      if(!valueResult){
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    return{
      formData:{
        premium_other: {
          gross:'',
          total_prm:''
        },
        is_match:'',
        is_match_tip:''
      },
      rules:{
        premium_input:[
          { validator: checkInput, trigger: ['change','blur'] }
        ]
      }
    }
  },
  computed:{
    showTotalTip(){
      let {premium_other={}} = this.formData||{}
      let {total_prm=0} =premium_other
      return this.amount!=premium_other
    },
    localAllOptions() {
      return this[`smeOptions${this.classId}`]||{}
    },
    list(){
      let {premium} = this.formData||{}
      return premium||[]
    },
    insureList(){
      let {insurer} = this.localAllOptions
      return insurer||[]
    },
    coupon_form(){
      let {premium_other} = this.formData
      let {coupon_code,code} = premium_other
      return {...this.form,coupon_code,code}
    }
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        if(val){
          let {premium,premium_other} = val
          this.formData = {...this.formData,premium,premium_other}
        }
      }
    }
  },
  methods:{
    handleOpenCoupon(){
      this.$emit('open')
    },
    submitForm(){
      return new Promise((resolve, reject) => {
        this.$refs['premiumForm'].validate((valid, rules) => {
          if (valid){
            resolve(this.formData)
          }else {
            this.scrollToValidDom(rules)
            reject()
          }
        })
      })
    },
    validateForm(){
      this.$refs['premiumForm'].validate((valid, rules) => {
        if (valid){
        }else {
          this.scrollToValidDom(rules)
        }
      })
    },
    applyCode(data){
      let {coupon={},code} = data
      if(JSON.stringify(data) != '{}'){
        if(coupon)
        {
          this.formData.premium_other.coupon_code = coupon.coupon_code
          this.formData.premium_other.code = ''
          this.formData.premium_other.code_disc_prm = 0
        }
        if(code){
          this.formData.premium_other.coupon_code = ''
          this.formData.premium_other.coupon_vl = ''
          this.formData.premium_other.code = code.code
        }
      }else {
        this.formData.premium_other.coupon_code = ''
        this.formData.premium_other.code = ''
        this.formData.premium_other.code_disc_prm = 0
        this.formData.premium_other.coupon_vl = ''
      }
      this.handleComputedData()

    },
    handleComputedData(){
      this.$refs['premiumForm'].validate((valid, rules) => {
        if (valid){
          this.network().getSMEReferMain(this.formData)
        }else {
          this.scrollToValidDom(rules)
        }
      })
    },
    handlerComputed(){
      this.handleComputedData()
    },
    network(){
      return{
        getSMEReferMain: async (params) => {
          const { data } = await getSMEReferMain({
            order_id: this.orderId,
            ...params,
            hideLoading: true
          })
          this.formData.is_match = data.is_match
          this.formData.is_match_tip = data.is_match_tip
          let {coverage,premium,premium_other} = this.formData
          Object.keys(data).some(key=>{
            premium.forEach(item=>{
              item.items.some(content=>{
                if(content.name==key)
                  content.val = data[key]
              })
            })

          })
          Object.keys(premium_other).some(item=>{
            if(data[item])
              premium_other[item] = data[item]
          })
          premium_other.gross = data.gross
          premium_other.total_prm = data.total_prm
        },

      }
    }
  }
}
</script>

<style scoped lang="scss">
.premium-box {
  width: 345px;
  //width: 500px;
  margin-bottom: 24px;

  .box {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #E1E4E8;
    border-radius: 8px;
    background: #F6F8FA;
    .table {
      margin-bottom: 0;
      .premium-table{
        .tr{
          border-bottom: 1px solid #D1D5DA!important;
          border-bottom-right-radius: 0!important;
          border-bottom-left-radius: 0!important;

        }
        &:first-child{
          .premium-item__title{
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
          }
        }
      }
      .premium-item__title{
        width: 100%;
        display: block;
        padding: 4px 16px;
        background: #F6F8FA;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        border-bottom: 1px solid #D1D5DA;
        color: #6A737D;
      }
      &.purple{
        background: #F5F0FF!important;
      }
      .error-tip{
        color: #CB2431;
        word-break: break-word;
        font-size: 12px;
      }
      .tr {
        //padding: 16px;
        height: 64px;
        padding: 0 16px;
        color: #586069;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        align-items: center;
        justify-content: space-between;
        background-color: #fff!important;
        &.blue_tr{
          background: #F1F8FF;
          border-top: 2px solid #0366D6;
        }
        &.purple_tr{
          background: #F5F0FF!important;
          border-top: 2px solid #6F42C1;
        }
        &:last-child {
          border-bottom: 0;
        }

        > span {
          flex: 2;
        }

        > div {
          flex: 2
        }
        .text-right{
          text-align: right;
        }
      }

      .tr:nth-child(2n) {
        background: none;
      }

      .tr:first-child{
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      .tr:last-child{
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      .style-2 {
        ::v-deep .el-input {
          width: 100px;
        }
      }

      .style-4 {
        background-color: #F6F8FA !important;
        &.blue_tr{
          background: #F1F8FF!important;
        }
        .span-right {
          color: #24292E;
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 0;
          line-height: 16px;
        }
        .min{
          text-align: center;
          color: #000;
        }
        .total{
          text-align: right;
          color: #000;
        }
      }

      .right {
        text-align: right;
        margin-left: 16px;
        //width: 80px;
      }

      .right-width {
        width: 69px;
      }

      .flex-algin {
        align-items: center;
        justify-content: flex-end;
      }
    }

  }

  ::v-deep .el-input-group__append {
    padding: 0 5px;
  }
}
</style>
